/* global google */
import getAdriaticStyles from '@PROJECT_ROOT/assets/shared/js/map/GoogleMapsStyles';
import MarkerWithLabel from '@google/markerwithlabel';

export default function guideGeoBeachSearch() {
    $.widget('ui.guideGeoBeachSearch', {
        options: {
            data: null,
            url: null,
            beachesUrl: null,
            links_container: '#geo_list_places',
            breadcrumbs_container: '#geo_breadcrumbs',
            center_link: '#geo_center',
            map: null,
            center: null,
            zoom: 9,
            country: '',
            polygons: [],
            last_request: null,
            image: null,
            type: null,
            id: null,
            backTitle: '',
            backButton: null,
        },
        _create() {
            const o = this.options;
            o.image = new google.maps.MarkerImage(
                'https://static.adriatic.hr/images/google/blank.png',
                new google.maps.Size(1, 1),
            );
            const widget = this;
            o.backButton = widget.createBackButton(o.backTitle);
            widget.renderJSONData('country', 'croatia');
        },
        createBackButton(backTitle) {
            const backButton = document.createElement('div');
            backButton.setAttribute('class', 'backUrl');
            backButton.innerHTML = backTitle;
            backButton.index = 1;
            $(backButton).on('click', () => {
                const widget = this;
                widget.renderJSONData('country', 'croatia');
            });

            return backButton;
        },
        showBackButton() {
            const o = this.options;
            const widget = this;
            widget.map.controls[google.maps.ControlPosition.TOP_CENTER].push(o.backButton);
        },
        hideBackButton() {
            const o = this.options;
            const widget = this;
            widget.map.controls[google.maps.ControlPosition.TOP_CENTER].pop(o.backButton);
        },
        render() {
            const o = this.options;
            const widget = this;

            $(o.links_container).html('');

            const mapOptions = {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: getAdriaticStyles(),
            };

            widget.map = new google.maps.Map(this.element[0], mapOptions);

            // Firefox scroll fix
            $(`#${this.element.attr('id')}`).on('MozMousePixelScroll', (event) => { event.preventDefault(); }, false);

            o.polygons = [];
            widget.renderPolygons();

            $(o.center_link).click(() => {
                if (o.data.centar && o.data.centar.lat) {
                    widget.map.setCenter(new google.maps.LatLng(o.data.centar.lat, o.data.centar.lng));
                    widget.map.setZoom(parseInt(o.data.zoom, 10));
                } else if (o.center) {
                    widget.map.setCenter(o.center);
                }
            });
        },
        destroy() {
            $.Widget.prototype.destroy.apply(this);
        },
        requestData(index) {
            const o = this.options;
            const widget = this;

            return function renderJSONDataOrRedirect() {
                const bounds = new google.maps.LatLngBounds();
                o.polygons[index].getPath().forEach((latlng) => {
                    bounds.extend(latlng);
                });
                o.center = bounds.getCenter();
                o.zoom = o.data.polygons[index].zoom;

                // Ako se radi o rivijeri? vrši redirekt na rivijeru
                if (o.data.areaType === 'riviera') {
                    $('#riviera').val(o.data.polygons[index].id);
                    const redirectUrl = `${o.beachesUrl}?${$('#beachSearchForm').serialize()}`;
                    $('#pageLoader').show();
                    document.location = redirectUrl;
                } else {
                    // Učitaj sve rivijere za pojedinu regiju
                    return widget.renderJSONData(o.data.areaType, o.data.polygons[index].id);
                }

                return null;
            };
        },
        renderJSONData(type, id) {
            const o = this.options;
            const widget = this;

            if (o.last_request !== null) {
                o.last_request.abort();
            }

            o.last_request = $.getJSON(o.url.replace('__TYPE__', type).replace('__ID__', id), (data) => {
                o.data = data;
                widget.render();

                if (type === 'country') {
                    widget.hideBackButton();
                } else if (type === 'region') {
                    widget.showBackButton();
                }
            });
        },
        renderPolygons() {
            const o = this.options;
            const widget = this;

            if (o.data.centar && o.data.centar.lat) {
                o.center = new google.maps.LatLng(o.data.centar.lat, o.data.centar.lng);
                this.map.setCenter(o.center);
                this.map.setZoom(parseInt(o.data.zoom, 10));
            } else if (o.center) {
                this.map.setCenter(o.center);
            }

            const markers = [];

            Object.keys(o.data.polygons).forEach((polygonIndex) => {
                const polygon = o.data.polygons[polygonIndex];
                widget.createLink(polygonIndex, polygon.id, polygon.name);
                const coordinates = [];

                Object.keys(polygon.coordinates).forEach((cooridnatesIndex) => {
                    coordinates[cooridnatesIndex] = new google.maps.LatLng(
                        polygon.coordinates[cooridnatesIndex].lat,
                        polygon.coordinates[cooridnatesIndex].lng,
                    );
                });

                o.polygons[polygonIndex] = new google.maps.Polygon({
                    paths: coordinates,
                    strokeColor: '#1f6fc0', // border_color.value,
                    strokeOpacity: 1, // border_color.weight,
                    strokeWeight: 1, // border_color.alpha,
                    fillColor: '#1975d2', // color.value,
                    fillOpacity: 0.40, // color.alpha
                });

                const bounds = new google.maps.LatLngBounds();
                o.polygons[polygonIndex].getPath().forEach((latlng) => {
                    bounds.extend(latlng);
                });

                markers[polygonIndex] = new MarkerWithLabel({
                    position: bounds.getCenter(),
                    icon: o.image,
                    title: polygon.name,
                    draggable: false,
                    raiseOnDrag: true,
                    map: this.map,
                    visible: true,
                    labelContent: polygon.name,
                    labelAnchor: new google.maps.Point(50, 25),
                    labelClass: 'LabeledMarker_markerLabel',
                    labelStyle: { opacity: 1 },
                });
                google.maps.event.addListener(markers[polygonIndex], 'click', widget.requestData(polygonIndex));
                google.maps.event.addListener(markers[polygonIndex], 'mouseover', function mouseoverSetZIndex() {
                    this.setZIndex(1000);
                });
                google.maps.event.addListener(markers[polygonIndex], 'mouseout', function mouseoutSetZIndex() {
                    this.setZIndex(10);
                });
            });

            Object.keys(o.polygons).forEach((index) => {
                o.polygons[index].setMap(this.map);
                $(`#place_${index}`).click(widget.requestData(index));

                google.maps.event.addListener(o.polygons[index], 'click', widget.requestData(index));
                google.maps.event.addListener(o.polygons[index], 'mouseover', function mouseoverSetOptions() {
                    this.setOptions({
                        strokeColor: '#ce7c00',
                        fillColor: '#ff9900',
                    });
                });
                google.maps.event.addListener(o.polygons[index], 'mouseout', function mouseoutSetOptions() {
                    this.setOptions({
                        strokeColor: '#1f6fc0',
                        fillColor: '#1975d2',
                    });
                });
            });
        },
        createLink(index, id, name) {
            const o = this.options;
            $(o.links_container).append(`<li><a id="place_${index}" href="javascript:;"><span class="check-outdent"></span>${name}</a></li>`);
        },
    });
}
